
import ProgressIndicator from "@/components/ProgressIndicator";
import {IonSegmentButton, IonSegment, IonLabel, IonButton, useIonRouter} from "@ionic/vue";
import {computed, ref, watch} from "vue";
import { useStore } from "@/composables/useTypedStore";
import {useRouter} from "vue-router";
import {Fragenblock} from "@/models/ba/Fragenblock";
import Bestandsaufnahme from "@/models/ba/Bestandsaufnahme";
import useScreenSize from "@/composables/useScreenSize";

export default {
  name: "BaTabs",
  components: {ProgressIndicator, IonSegment, IonSegmentButton, IonLabel, IonButton},
  props: {
    selectedView: {
      type: String,
      default: undefined
    },
  },
emits: ['showSummary', 'goTo'],
  setup(props: any, { emit }: { emit: any}) {
    const store = useStore();
    const router = useRouter();
    const prevRoute = ref();
    const ionRouter = useIonRouter();


    const { isMinLarge } = useScreenSize();

    let currentTab = '';

    const ba = computed<Bestandsaufnahme | undefined>(() => {
      return store.state.currentHzba.currentBa;
    });

    const tabs = computed<Fragenblock[] | undefined>(() => {
      return ba.value?.fragenblocks
    })

    watch([tabs], (newVal) => {
      tabs.value?.forEach(el => el.setupUnlockDetector())
    }, { immediate: true })

    const changeRoute = (e: any) => {
      // console.log("change route", e.detail.value)
      if (currentTab !== e.detail.value && e.detail.value) {
        currentTab = e.detail.value;
        // router.replace(`/ba/${ba.value!.id}/${e.detail.value}`)

        emit('changeTab', e.detail.value);
        // ionRouter.navigate(`/ba/${ba.value!.id}/${e.detail.value}`, 'root', 'replace', undefined);
      }
    }

    const changeRouteDesktop = (tab: Fragenblock) => {
      // router.replace(`/ba/${ba.value!.id}/${tab.identifier}`)
      // ionRouter.navigate(`/ba/${ba.value!.id}/${tab.identifier}`, 'root', 'replace', undefined);

      emit('changeTab', tab.identifier);
    }

    const goToSummary = () => {
      emit('showSummary');
    }

    return {ba, tabs, goToSummary, changeRoute, changeRouteDesktop, isMinLarge}
  }
}
